import { NotificationMode } from '../types/notification-mode';

/**
 * Gets the appropriate icon name for a notification mode
 * @param mode The notification mode
 * @returns The icon name corresponding to the mode
 */
export function getNotificationIcon(mode: NotificationMode): string {
  const iconMap: Record<NotificationMode, string> = {
    success: 'check',
    error: 'error',
    warning: 'warning',
    info: 'info'
  };

  return iconMap[mode];
}
